module.exports = __webpack_public_path__ + "static/media/fingerprint.99425009.svg";